<template>
  <div class="tab-1 container-v2">
    <div class="portfolio-news-list">
      <div v-if="loading" class="wrapperLoading">
        <div class="lds-dual-ring"></div>
      </div>

      <template v-else>
        <div
          v-for="item in listData"
          :key="item.id"
          class="portfolio-news-item"
        >
          <div class="mine-card-1">
            <div class="logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 191 194"
                fill="none"
              >
                <path
                  d="M61.2287 15.2449C70.2737 10.1639 79.3227 5.08278 88.3756 0.00170898C88.3822 48.2667 88.3822 96.5317 88.3756 144.797L-0.000244141 193.751V167.173C20.4107 155.936 40.8204 144.697 61.2287 133.456C61.2221 122.614 61.2221 111.771 61.2287 100.927C47.8112 108.231 34.3983 115.536 20.99 122.841C20.9834 113.981 20.9834 105.126 20.99 96.2744C34.3943 88.9707 47.8026 81.6663 61.2149 74.3613C61.24 54.6623 61.2446 34.9569 61.2287 15.2449Z"
                  fill="#0095FF"
                />
                <path
                  d="M102.624 -0.000244141C111.676 5.07432 120.725 10.1554 129.771 15.243C129.771 34.9523 129.771 54.6597 129.771 74.3652C143.182 81.6611 156.586 88.9629 169.984 96.2705C169.977 105.13 169.977 113.985 169.984 122.837C156.58 115.533 143.175 108.231 129.771 100.931C129.764 111.774 129.764 122.617 129.771 133.46C150.175 144.71 170.585 155.949 191 167.177C190.993 176.036 190.993 184.892 191 193.743C161.541 177.432 132.086 161.116 102.634 144.797L102.624 -0.000244141Z"
                  fill="#0095FF"
                />
              </svg>
            </div>

            <div class="fuel-title">
              <span>Fuel Venture Capital</span>
              {{ $filters.format(item.pub_date, "MMM DD, YYYY") }}
            </div>
          </div>

          <div class="thumbnail" @click="redirectUrl(item.link)">
            <img
              :src="item.photo"
              alt="thumbnail"
              onerror="this.onerror=null;this.src='/public/images/default.jpeg';"
            />
          </div>

          <a class="title" :href="item.link" target="_blank">
            {{ item.title }}
          </a>
        </div>
      </template>
    </div>

    <div
      v-if="paging.total > paging.size"
      class="row justify-content-center mb-3 mt-5"
    >
      <pager
        :loadContentAtPage="loadPage"
        :page="paging.page"
        :size="paging.size"
        :total="paging.total"
        :pagerFull="true"
        customClass="pagination-v2"
      ></pager>
    </div>
  </div>
</template>

<script>
import NewsService from "@/services/news/news";
export default {
  data() {
    return {
      loading: false,
      listData: [],
      paging: {
        page: 1,
        size: 9,
        total: 0,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    redirectUrl(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
    loadPage(value) {
      this.paging.page = value;
      this.getData();
    },
    getData() {
      let me = this;
      this.loading = true;
      NewsService.getAll(this.paging).then((resp) => {
        if (resp.data.ok && resp.data.d.t) {
          this.listData = resp.data.d.c;
          me.paging = {
            total: resp.data.d.t,
            page: resp.data.d.p,
            size: resp.data.d.s,
          };
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-1 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.portfolio-news-list {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  min-height: 50vh;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  .portfolio-news-item {
    .thumbnail {
      --ratio: 1.5/1;
      cursor: pointer;
      filter: grayscale(100%);
      height: 0;
      object-fit: cover;
      object-position: center;
      padding-bottom: calc(100% / (var(--ratio)));
      position: relative;
      width: 100%;
      z-index: 2;
      transition: all 0.3s ease;

      &:hover {
        filter: unset;
        transition: all 0.3s ease;
      }

      border: 1px solid #cecece;
      img {
        height: 100%;
        left: 0;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        width: 100%;
      }
    }

    .title {
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
      color: #000;

      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
